import { expandToBackendURL } from '@plone/volto/helpers';
export const GET_DAY_BUSY_SLOTS = 'GET_DAY_BUSY_SLOTS';

/**
 * Get Day busy slots
 * @function getDayBusySlots
 */
export function getDayBusySlots(folderPath, date) {
  const path = `${expandToBackendURL(folderPath)}/@day/${date ?? ''}`;
  return {
    type: GET_DAY_BUSY_SLOTS,
    request: {
      op: 'get',
      path: path,
    },
  };
}
